const en = {
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "search": "Search",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "submit": "Submit",
    "update": "Update",
    "view": "View",
    "download": "Download",
    "upload": "Upload",
    "select": "Select",
    "all": "All",
    "none": "None",
    "yes": "Yes",
    "no": "No"
  },
  "nav": {
    "dashboard": "Dashboard",
    "createAd": "Create Ad",
    "campaigns": "Campaigns",
    "insights": "Insights",
    "contextiq": "ContextIQ",
    "adGallery": "Ad Gallery",
    "university": "University",
    "managedServices": "Managed Services",
    "resources": "Resources",
    "settings": "Settings",
    "signOut": "Sign Out",
    "help": "Help & Resources"
  },
  "header": {
    "searchPlaceholder": "Search campaigns, creatives...",
    "notifications": "Notifications",
    "viewAllNotifications": "View all notifications",
    "accountSettings": "Account Settings",
    "manageSubscription": "Manage Subscription",
    "upgradePlan": "Upgrade Plan",
    "updateProfile": "Update Profile",
    "takeTour": "Take a Tour",
    "language": "Language"
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Welcome back",
    "overview": "Overview",
    "recentCampaigns": "Recent Campaigns",
    "topPerformingAds": "Top Performing Ads",
    "quickActions": "Quick Actions",
    "createNewAd": "Create New Ad",
    "viewCampaigns": "View Campaigns",
    "viewInsights": "View Insights",
    "impressions": "Impressions",
    "clicks": "Clicks",
    "ctr": "CTR",
    "spend": "Spend",
    "conversions": "Conversions",
    "revenue": "Revenue",
    "performance": "Performance",
    "thisMonth": "This Month",
    "lastMonth": "Last Month",
    "contextiqWidget": {
      "title": "ContextIQ Insights",
      "brandMatches": "Brand Matches",
      "alignmentScore": "Alignment Score",
      "topOpportunities": "Top Opportunities",
      "viewAll": "View All"
    }
  },
  "campaigns": {
    "title": "Campaigns",
    "subtitle": "Manage and monitor your advertising campaigns",
    "createCampaign": "Create Campaign",
    "allCampaigns": "All Campaigns",
    "active": "Active",
    "paused": "Paused",
    "completed": "Completed",
    "draft": "Draft",
    "scheduled": "Scheduled",
    "status": "Status",
    "budget": "Budget",
    "startDate": "Start Date",
    "endDate": "End Date",
    "noCampaigns": "No campaigns yet",
    "createFirst": "Create your first campaign to get started"
  },
  "insights": {
    "title": "Insights",
    "subtitle": "Analyze your campaign performance",
    "campaigns": "Campaigns",
    "creatives": "Creatives",
    "audience": "Audience",
    "dateRange": "Date Range",
    "export": "Export",
    "metrics": {
      "totalImpressions": "Total Impressions",
      "totalClicks": "Total Clicks",
      "averageCtr": "Average CTR",
      "totalSpend": "Total Spend",
      "costPerClick": "Cost Per Click",
      "conversionRate": "Conversion Rate"
    }
  },
  "contextiq": {
    "title": "ContextIQ",
    "subtitle": "AI-powered contextual targeting",
    "brandAnalysis": "Brand Analysis",
    "contentMatching": "Content Matching",
    "opportunities": "Opportunities",
    "safetyScore": "Brand Safety Score",
    "alignmentScore": "Alignment Score",
    "analyzeUrl": "Analyze URL",
    "enterUrl": "Enter URL to analyze",
    "analyze": "Analyze",
    "results": "Results",
    "noResults": "No results yet",
    "startAnalyzing": "Enter a URL above to start analyzing"
  },
  "gallery": {
    "title": "Ad Gallery",
    "subtitle": "Browse and manage your creative assets",
    "uploadNew": "Upload New",
    "allCreatives": "All Creatives",
    "images": "Images",
    "videos": "Videos",
    "html5": "HTML5",
    "templates": "Templates",
    "sortBy": "Sort by",
    "newest": "Newest",
    "oldest": "Oldest",
    "name": "Name",
    "noCreatives": "No creatives yet",
    "uploadFirst": "Upload your first creative to get started"
  },
  "university": {
    "title": "Adventive University",
    "subtitle": "Master interactive advertising",
    "courses": "Courses",
    "certifications": "Certifications",
    "resources": "Resources",
    "progress": "Your Progress",
    "completedCourses": "Completed Courses",
    "inProgress": "In Progress",
    "startLearning": "Start Learning",
    "continueLearning": "Continue Learning",
    "viewCourse": "View Course",
    "certificate": "Certificate"
  },
  "managedServices": {
    "title": "Managed Services",
    "subtitle": "Let our experts build your ads",
    "newRequest": "New Request",
    "activeRequests": "Active Requests",
    "completedRequests": "Completed Requests",
    "requestStatus": {
      "pending": "Pending",
      "inProgress": "In Progress",
      "review": "In Review",
      "completed": "Completed",
      "needsInput": "Needs Input"
    },
    "submitRequest": "Submit Request",
    "requestDetails": "Request Details"
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Manage your account preferences and settings",
    "profile": "Profile",
    "organization": "Organization",
    "team": "Team",
    "notifications": "Notifications",
    "security": "Security",
    "billing": "Billing",
    "preferences": "Preferences",
    "language": "Language",
    "timezone": "Timezone",
    "theme": "Theme",
    "darkMode": "Dark Mode",
    "lightMode": "Light Mode",
    "systemDefault": "System Default",
    "restartTour": "Restart Platform Tour",
    "restartTourDesc": "Take a guided tour of the platform features",
    "profileInfo": {
      "title": "Profile Information",
      "subtitle": "Update your personal details and preferences",
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email Address",
      "phone": "Phone Number",
      "changePhoto": "Change Photo",
      "photoHint": "JPG, PNG or GIF. Max 2MB."
    },
    "organizationInfo": {
      "title": "Organization Details",
      "subtitle": "Manage your organization information",
      "name": "Organization Name",
      "type": "Organization Type",
      "industry": "Industry",
      "website": "Website",
      "address": "Address"
    },
    "teamMembers": {
      "title": "Team Members",
      "subtitle": "Manage your team",
      "inviteMember": "Invite Member",
      "role": "Role",
      "admin": "Admin",
      "editor": "Editor",
      "viewer": "Viewer",
      "pending": "Pending"
    },
    "notificationPrefs": {
      "title": "Notification Preferences",
      "subtitle": "Choose how you want to be notified",
      "campaignUpdates": "Campaign Updates",
      "campaignUpdatesDesc": "Get notified when campaigns go live, pause, or complete",
      "performanceReports": "Performance Reports",
      "performanceReportsDesc": "Receive daily or weekly performance summaries",
      "creativeApprovals": "Creative Approvals",
      "creativeApprovalsDesc": "Get notified when creatives are approved or need revision",
      "usageAlerts": "Usage Alerts",
      "usageAlertsDesc": "Get notified when approaching or exceeding impression limits",
      "pushNotifications": "Push Notifications",
      "pushNotificationsDesc": "Receive real-time browser notifications",
      "weeklyDigest": "Weekly Digest",
      "weeklyDigestDesc": "Get a weekly summary of your account activity"
    },
    "securitySettings": {
      "title": "Security Settings",
      "subtitle": "Manage your account security",
      "changePassword": "Change Password",
      "changePasswordDesc": "Update your password regularly for security",
      "twoFactor": "Two-Factor Authentication",
      "twoFactorDesc": "Add an extra layer of security to your account",
      "notEnabled": "Not enabled",
      "enabled": "Enabled",
      "activeSessions": "Active Sessions",
      "currentSession": "Current Session",
      "activeNow": "Active now"
    },
    "billingSettings": {
      "title": "Billing",
      "overview": "Overview",
      "usage": "Usage",
      "invoices": "Invoices",
      "payments": "Payments",
      "planHistory": "Plan History",
      "currentPlan": "Current Plan",
      "changePlan": "Change Plan",
      "paymentMethod": "Payment Method",
      "billingInfo": "Billing Information",
      "updatePayment": "Update Payment Method",
      "impressionsUsed": "Impressions Used",
      "cpmRate": "CPM Rate",
      "overage": "Overage",
      "overageCost": "Overage Cost"
    },
    "saveChanges": "Save Changes",
    "changesSaved": "Changes saved successfully"
  },
  "tour": {
    "welcome": {
      "title": "Welcome to Adventive!",
      "description": "Let's take a quick tour to help you get started with the platform. You'll learn how to create ads, manage campaigns, and access powerful insights."
    },
    "dashboard": {
      "title": "Your Dashboard",
      "description": "This is your command center. View key metrics, recent campaigns, and quick actions all in one place. The dashboard gives you a real-time overview of your advertising performance."
    },
    "createAd": {
      "title": "Create Your First Ad",
      "description": "Click here to start building interactive, engaging ads. Our drag-and-drop builder makes it easy to create rich media ads without any coding.",
      "action": "Start by creating your first ad"
    },
    "campaigns": {
      "title": "Manage Campaigns",
      "description": "Organize and track all your advertising campaigns. Set budgets, schedules, and targeting options. Monitor performance in real-time."
    },
    "insights": {
      "title": "Powerful Insights",
      "description": "Dive deep into your campaign performance. Analyze impressions, clicks, engagement rates, and audience behavior with detailed analytics."
    },
    "contextiq": {
      "title": "ContextIQ Intelligence",
      "description": "Our AI-powered contextual targeting helps you reach the right audience at the right moment. Analyze content, find brand alignments, and discover opportunities."
    },
    "gallery": {
      "title": "Ad Gallery",
      "description": "Access all your creatives in one place. Preview, duplicate, edit, or archive your ads. Keep your creative library organized and accessible."
    },
    "managedServices": {
      "title": "Managed Services",
      "description": "Need help? Our expert team can build custom ads for you. Submit a request and we'll handle the creative work while you focus on strategy."
    },
    "university": {
      "title": "Adventive University",
      "description": "Level up your skills with our learning resources. Access tutorials, best practices, and certification courses to become an interactive advertising expert."
    },
    "complete": {
      "title": "You're All Set!",
      "description": "You're ready to start creating amazing interactive ads. If you need help at any time, check out our Resources section or contact support."
    },
    "skipTour": "Skip tour",
    "getStarted": "Get Started"
  },
  "plan": {
    "base": "Base",
    "professional": "Professional",
    "enterprise": "Enterprise",
    "upgrade": "Upgrade",
    "current": "Current Plan",
    "perMonth": "/month"
  },
  "brands": {
    "currentView": "Current View",
    "allBrands": "All Brands",
    "selectBrand": "Select Brand",
    "addBrand": "Add Brand",
    "noBrands": "No brands added yet",
    "addBrandsHint": "Add brands to manage multiple clients"
  },
  "errors": {
    "somethingWentWrong": "Something went wrong",
    "tryAgain": "Please try again",
    "notFound": "Page not found",
    "unauthorized": "Unauthorized access",
    "networkError": "Network error"
  },
  "time": {
    "justNow": "Just now",
    "minutesAgo": "{{count}} min ago",
    "hoursAgo": "{{count}} hour ago",
    "hoursAgo_plural": "{{count}} hours ago",
    "daysAgo": "{{count}} day ago",
    "daysAgo_plural": "{{count}} days ago"
  }
};

export default en;
